<template>
    <section class="view spacer">
        <vue-headful
            title="IT View | What goes into a IT View"
            description="IT View visualizes the alignment of all information technology (IT) investments across your organization. Optimize IT portfolio management and identify cost-reduction and consolidation opportunities."
            url="https://www.fedsight.com/it-view"
        />
        <section class='container-fluid d-flex align-items-center justify-content-center'>
        </section>

        <section class='viewIntro'>
            <div class='container'>
                <h1 class='viewHeader fedsightBlue'>IT VIEW</h1> 
                <p class='viewMainParagraph'>
                    Scrutiny and oversight is ever increasing with federal IT investments, which means IT investment stakeholders require greater visibility and analytics to manage as well as report to oversight bodies. IT View provides financial and functional visibility into the IT/IM function in a manner that supports day-to-day operational reporting as well as in-depth analytics and scenario analysis. Multiple classification schemas enhance your ability to understand mission alignment and rapidly identify, analyze, and model opportunities to optimize IT management and spending.
                </p>
            </div>
            
        </section>

        <section class='blogPost'>
            <div class='container blogPostContainer'>
                <h2 class='fedsightBlue' style='margin-top: 0rem;'>
                    Key Business Questions:
                </h2>
                <ul>
                    <li>
                        What are the trends and overall composition of the IT function including federal employees, real estate, contracts, working capital fund, and IT assets in terms of costs and trends overall, by organization, and by program?
                    </li>
                    <li>
                        How are IT investments aligned to various areas including programmatic, organizational, and IT functional areas (infrastructure, applications, etc.)?
                    </li>
                    <li>
                        Are there IT contracts that overlap organizationally, programmatically, geographically, or functionally for similar products and services.
                    </li>
                    <li>
                        What are the costs and historical trends for IT by organization, support function, and program in terms of percentage of cost, cost per employee, etc. and analysis of whether IT investments optimized to meet mission and other requirements?
                    </li>
                    <li>
                        How does the cost for products or services compare in terms of rate, cost per employee, and unit to what other organizations are paying?
                    </li>
                    <li>
                        What have been the trends related to using contracts vs. employees to execute key IT functions and is the balance in sync with mission and cost objectives?
                    </li>
                </ul>
            </div>

            <div class='container blogPostContainer'>
                <h2 class='fedsightBlue' style='margin-top: 0rem;'>
                    Who we are
                </h2>
                <p>
                    Fedsight Consulting is an SBA certified HUBZone small business consulting firm focused on helping organizations improve operations and program performance. Our strategic, financial, and operational support services provide insight and perspective on program performance and operational trends.  Fedsight Consulting’s subject matter expertise, methods, and tools enable federal organizations to accomplish objectives, effectively manage resources, and improve program performance.
                </p>
                <p>
                    To learn more about Fedsight Consulting and discuss potential opportunities, email <span class='emailLink' @click='emailUs()'>info@fedsight.com</span>.
                </p>
            </div>
        </section>

        <Footer />
  </section>
</template>

<script>
import Footer from '@/components/Footer.vue'
import closeMenu from '../../mixins/closeMenu'


export default {
    name: 'it-view',
    components: {
        Footer
    },
    metaInfo: {
      link: [
        {rel:'canonical', href:'https://www.fedsight.com/it-view'}
      ]
    },
    mixins: [closeMenu],
    methods: {
      emailUs(){
          window.location.href = "mailto:info@fedsight.com?subject=I%20would%20like%20to%20learn%20more%20about%20Fedsight&body=Hello,%0D%0A%0D%0APlease%20contact%20me%20to%20discuss%20how%20Fedsight%20can%20assist%20my%20company.%0D%0A%0D%0A";
      }
    },
    beforeMount: function (){
        let link = document.createElement('link');
        link.setAttribute('rel', 'canonical');
        link.setAttribute('href', 'https://www.fedsight.com/it-view');
        link.content = document.location;
        document.getElementsByTagName('head')[0].appendChild(link);
    },
  mounted() {
    document.dispatchEvent(new Event('page.rendered'));
  }
}
</script>

<style scoped>
.viewIntro{
    padding: 8rem 0rem 2rem;
    max-width: 100rem;
    margin: auto;
    text-align: left;
}
.viewHeader{
    font-size: 4rem;
    font-weight: bold;
    text-align: center;
    /*background-color: #132631;
    color: #fff; */
    width: 100%;
    padding: 2rem 0rem;
}
.blogPost{
    text-align: left;
}
.blogPostContainer{
    max-width: 100rem;
    margin: 3rem auto;
}
.viewHero{
    height: 30rem;
}
.viewHeader{
    color: #fff;
    font-size: 6rem;
}
.emailLink{
    color: #007bff;
    cursor: pointer;
}
.emailLink:hover{
    color: #0056b3;
    text-decoration: underline;
}
h2{
    margin-top: 3rem;
}


/* Small devices (landscape phones, 576px and up) */
  @media (max-width: 576px) { 
    .slogan {
      font-size: 3.5rem !important;
    }
  }

  @media (max-width: 768px) { 
    .slogan{
      text-align: center;
      margin-left: auto;
      margin-right: auto;
    }
  }

  @media (max-width: 992px){
    .container{
        padding: 1.5rem !important;
    }
  }

  /* Extra large devices (large desktops, 1200px and up) */
  @media (min-width: 1200px) { 
    
    .slogan {
      font-size: 9rem !important;
    }
  }
</style>